import { z } from "zod";
import { MAX_TEXT_SHORT } from "../constants.js";
import { paginationQuerySchema } from "./common.js";

// 学校アカウント発行（管理者）。1校1アカウント。
export const schoolCreateInputSchema = z.object({
  name: z.string().trim().min(1, "学校名は必須です").max(MAX_TEXT_SHORT),
  area: z.string().trim().min(1, "エリアは必須です").max(MAX_TEXT_SHORT),
  // ログインアカウント（教員共有）
  loginEmail: z.string().email("ログイン用メールの形式が正しくありません"),
  contactName: z.string().trim().min(1, "担当者名は必須です").max(MAX_TEXT_SHORT),
  password: z.string().min(12, "パスワードは12文字以上にしてください").max(200),
});
export type SchoolCreateInput = z.infer<typeof schoolCreateInputSchema>;

export const schoolSchema = z.object({
  id: z.string(),
  name: z.string(),
  area: z.string(),
  createdAt: z.string(),
});
export type School = z.infer<typeof schoolSchema>;

export const schoolListQuerySchema = paginationQuerySchema;
export type SchoolListQuery = z.infer<typeof schoolListQuerySchema>;
